export default {
  smsTemplate: "SmsTemplate",
  addSmsTemplate: "AddSmsTemplats",
  editSmsTemplate: "EditSmsTemplate",
};
